import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useSettings } from "@/context/SettingsContext";

const stats = [
  { value: "500+", label: "Families Served" },
  { value: "1000+", label: "Individuals Educated" },
  { value: "1", label: "Mission — Cashflow" },
];

export default function About() {
  const ref = useRef(null);
  const { settings } = useSettings();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="about" data-testid="about" className="relative z-10 py-24 md:py-32 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div ref={ref} className="relative h-[420px] sm:h-[560px] overflow-hidden order-2 lg:order-1 border border-border">
            <motion.div style={{ y }} className="absolute inset-[-12%]">
              <img
                src={settings.about_photo || "https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=1200&q=80&auto=format&fit=crop"}
                alt="Cashflow model architecture"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-background/40" />
            </motion.div>
            <div className="absolute bottom-0 left-0 bg-primary text-primary-foreground px-6 py-4">
              <p className="font-display font-black uppercase tracking-tight text-lg leading-none">Adarsh</p>
              <p className="font-mono-accent text-[11px] uppercase tracking-[0.15em] mt-1">Founder & CEO, PBA Capital</p>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <p className="font-mono-accent text-xs uppercase tracking-[0.25em] text-primary mb-5">/ The Architect</p>
            <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl mb-8">
              Warm greetings, investors
            </h2>
            <div className="space-y-5 text-muted-foreground text-base sm:text-lg leading-relaxed max-w-xl">
              <p>
                I&apos;m Adarsh, Founder &amp; CEO of PBA Capital, on a mission of helping Indian
                investors build <span className="text-foreground font-semibold">#cashflow systems</span> through disciplined investing.
              </p>
              <p>
                Design My Cashflow is an educational initiative by PBA Capital — Pyramid Brokers
                and Associates LLP, a registered trademark and SEBI-registered entity.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-12">
              {stats.map((s, i) => (
                <motion.div
                  key={s.label}
                  data-testid={`about-stat-${i}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.6 }}
                  className="border border-border p-4 sm:p-6"
                >
                  <p className="font-display font-black text-3xl sm:text-4xl text-primary leading-none">{s.value}</p>
                  <p className="font-mono-accent text-[10px] sm:text-[11px] uppercase tracking-[0.12em] text-muted-foreground mt-3 leading-tight">{s.label}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
